import { Button, Row } from "components/ui-kit/styled-templates";

import { togglePush } from "services/common-service";

type TOption = {
    value: any;
    label: string;
};

const ButtonGroup = (props: { value: any; onChange: Function; options: TOption[]; multiselect?: boolean }) => {
    const { value, onChange = () => {}, options = [], multiselect = false } = props;
    let propsValue = value;
    if (!!multiselect && !Array.isArray(value)) {
        propsValue = [value];
    }
    return (
        <Row extra={`gap: 15px; flex-wrap: wrap; justify-content: flex-start;`}>
            {options.map(({ value, label }, index) => {
                const isSelected = multiselect ? propsValue.includes(value) : propsValue === value;
                return (
                    <Button
                        key={index}
                        variant={isSelected ? "primary" : "outlined"}
                        onClick={() => {
                            onChange({
                                target: { value: multiselect ? togglePush(propsValue, value) : value },
                            });
                        }}
                    >
                        {label}
                    </Button>
                );
            })}
        </Row>
    );
};

export default ButtonGroup;
